import { createReducer, on } from '@ngrx/store';
import { saveDifferentLocations } from './differentLocations.actions';

export const saveDifferentLocationsReducer = (
    _: any,
    { value }: { value: any },
): any => value;

export const DifferentLocationsReducer = createReducer(
    [],
    on(saveDifferentLocations, saveDifferentLocationsReducer),
);
